import { Box, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import DinamicTable from 'components/dinamic-table'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import Page from 'components/page'
import Wrapper from 'components/wrapper'
import { useState } from 'react'
import { generateRandomAdherenceRows } from './random'

interface AdesaoCustomTableProps {
  tableLabel: string
  organizationName: string
  backRoute: string
  projectIsInactive: boolean
}

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
    position: 'relative',
  },
}))

const AdesaoCustomTable = ({ backRoute, tableLabel, organizationName, projectIsInactive }: AdesaoCustomTableProps) => {
  const [rowsPerPage, setRowsPerPage] = useState<number>(10)
  const [page, setPage] = useState<number>(1)

  const classes = useStyles()

  const tableData = {
    data: generateRandomAdherenceRows(10),
    count: 104,
  }

  return (
    <Wrapper>
      <Header>
        <HeaderModule.title
          text={tableLabel}
          backRoute={backRoute}
        />
      </Header>
      <Page>
        <Box className={classes.root}>
          <DinamicTable
            data={tableData.data}
            rowsPerPage={rowsPerPage}
            page={page}
            isLoading={false}
            totalPages={Math.ceil(tableData.count || 0 / rowsPerPage)}
            handleNextPage={() => setPage(page + 1)}
            handlePrevPage={() => setPage(page - 1)}
            onChangeRowPerPage={(value) => {
              setRowsPerPage(value)
              setPage(1)
            }}
          />
        </Box>
      </Page>
    </Wrapper>
  )
}

export default AdesaoCustomTable
